import type { API } from 'chessboard/api/config/types';
import { Core } from 'chessboard/core/config/types';
import type { Game } from 'chessboard/model/game/types';
import { HighlightType } from 'chessboard/plugins/highlights/config/types';

/**
 * Create the blinkHighlight method.
 */
export function createBlinkHighlight(context: API.Context) {
  /**
   * Blink a square.
   */
  return function blinkHighlight(blinkingHighlight: Game.Highlight.Blinking.Model): API.Response {
    const { respond } = context;

    const highlight = {
      data: blinkingHighlight,
      type: HighlightType,
    };

    return respond(Core.APIEvents.BlinkHighlight, [highlight]);
  };
}
